import { AutoComplete as RefAutoComplete, AutoCompleteProps } from 'antd';

export type { AutoCompleteProps };
export const AutoComplete = RefAutoComplete;
